export const DOT_SIZE = 6;
export const DOT_GAP = 4;

export function maxDotsPerRow(availableWidth, {dotSize = DOT_SIZE, gap = DOT_GAP} = {}) {
  const stride = dotSize + gap;
  if(!(availableWidth > 0) || stride <= 0) return 1;
  return Math.max(1, Math.floor((availableWidth + gap) / stride));
}

export function balancedDotsPerRow(count, maxPerRow) {
  if(!(count > 0) || !(maxPerRow > 0)) return 1;
  if(count <= maxPerRow) return count;
  const rows = Math.ceil(count / maxPerRow);
  return Math.ceil(count / rows);
}

export function balancedDotRowContentWidth(count, availableWidth, sizes = {}) {
  const {dotSize = DOT_SIZE, gap = DOT_GAP} = sizes;
  const maxPerRow = maxDotsPerRow(availableWidth, sizes);
  const perRow = balancedDotsPerRow(count, maxPerRow);
  return perRow * (dotSize + gap) - gap;
}

export function applyBalancedDotRows(dotsEl, sizes = {}) {
  if(!dotsEl || typeof dotsEl.querySelectorAll !== 'function') return;

  dotsEl.style.maxWidth = '';
  const count = [...dotsEl.children].filter((el) => el.classList && el.classList.contains('dot')).length;
  if(count < 2) return;

  const styles = typeof window !== 'undefined' && window.getComputedStyle
    ? window.getComputedStyle(dotsEl)
    : null;
  const padX = styles
    ? (parseFloat(styles.paddingLeft) || 0) + (parseFloat(styles.paddingRight) || 0)
    : 0;
  const available = Math.max(0, (dotsEl.clientWidth || 0) - padX);
  if(available <= 0) return;

  const maxPerRow = maxDotsPerRow(available, sizes);
  if(count <= maxPerRow) return;

  dotsEl.style.maxWidth = `${balancedDotRowContentWidth(count, available, sizes) + padX}px`;
}
